import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { InitOptions } from "i18next";

// Import des traductions
import translationFR from "./locales/fr/translation.json";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";

// Les ressources de traduction
const resources = {
  fr: {
    translation: translationFR,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

const i18nConfig: InitOptions = {
  resources,
  fallbackLng: "fr", // Langue par défaut si la traduction n'existe pas
  debug: process.env.NODE_ENV === "development",

  interpolation: {
    escapeValue: false, // React échappe déjà les valeurs
  },

  // Options de détection de la langue
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  },

  // Configuration React
  react: {
    useSuspense: true,
  },
};

i18n
  // Détection automatique de la langue du navigateur
  .use(LanguageDetector)
  // Passe l'instance i18n à react-i18next
  .use(initReactI18next)
  // Initialisation de i18next
  .init(i18nConfig);

export default i18n;

// Types pour TypeScript
declare module "react-i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      translation: typeof translationFR;
    };
  }
}
